<template>
  <div id="app">
    <h1>EFSA BPA project</h1>
    <h2>Summary tables</h2>

    <BpaTable />
  </div>
</template>

<script>
import BpaTable from './components/BpaTable'

export default {
  name: 'app',
  components: {
    BpaTable
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
